module.exports = __webpack_public_path__ + "img/media-13.7726ea20.png";